import { loadSlangListAPI, ProductSlangDetailModel, ProductSlangListParameters } from "@bToC/Services/ProductSlangListService";
import {
    ApiHandler,
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<ProductSlangListParameters, ProductSlangDetailModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await loadSlangListAPI(props.apiParameter);
};

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
];

const gerrieLoadSlangListAPIHandler = createHandlerChainRunner(chain, "GerrieLoadSlangListAPIHandler");
export default gerrieLoadSlangListAPIHandler;